import React, { useState, useEffect } from "react";
import API from '../api/index';

function EducationItem(from,to,standard,university,location,index){
	return(
		<div class="col-md-6 content-item" key={index}>
			<small>{from} - {to}</small>
			<h3>{standard}</h3>
			<h4>{university}</h4>
			<p>{location}</p>
		</div>
	)
}

function Education(){
	const [educationData, setEducationData] = useState([]);
	let count = 1;

	useEffect(() => {
		let educationData = API.getEducation();
		educationData.then(
			response => {
				setEducationData(response.records)
			}
		);
	}, [count]);

	return(
		<section class="section-wrapper section-education gray-bg">
			<div class="container-fluid">
				<div class="row">
					<div class="col-md-12">
						<div class="section-title"><h2>Education</h2></div>
					</div>
				</div>
				
				<div class="row">
					{
						educationData	?	
							educationData.map((item,index) => 
								EducationItem(item.fields.Start, item.fields.End, item.fields.Standard, item.fields.University, item.fields.Location, index)
							)
						:	<></>
					}
				</div>
			</div>

		</section>
	)
}

export default Education;